import React, { useEffect, useContext } from 'react';
import styled from 'styled-components';

import MainSection from "./main-section/MainSection";
import Testimonial from "./testimonial/Testimonial";
import SuccessStories from "./success-stories/SuccessStories";
import Header from "./header/Header";
import Footer from "./footer/Footer";
import { Wrapper } from "../common/styled-components/styled-components";

import { breakpoints } from '../../../app/js/utils/responsive_utilities';
import { assetPath } from '../../../app/js/utils/web-helper';
import { SemContext } from '../context/SemContext';

import { setVariant } from "../actions/actions"
import DesktopBackground from '~images/sem/bg_desk.png';

const HomepageWrapper = styled.div`
  @media (min-width: ${breakpoints.xl}px) {
    z-index: 10;
    background: url(${assetPath(DesktopBackground)}) left/cover no-repeat;
  }
`;

const PromoPageV1 = (props) => {
  let { state, dispatch } = useContext(SemContext);
  useEffect(() => {
    const variant = (props.match && props.match.params.version) || "1";
    if(variant != state.variant)
      dispatch(setVariant(variant));
    if (typeof (dataLayer) != "undefined") {
      trackToGtm(dataLayer, 'promo page loaded', 'promo page loaded');
    }

    props.trackPromoPageEvents("Promo Page Viewed");
  }, []);

  return (
    <Wrapper>
      <Header />
      <HomepageWrapper>
        <MainSection settings={state.settings} trackPromoPageEvents={props.trackPromoPageEvents} />
        <Testimonial trackPromoPageEvents={props.trackPromoPageEvents} />
        <SuccessStories settings={state.settings} trackPromoPageEvents={props.trackPromoPageEvents}/>
        <Footer />
      </HomepageWrapper>
    </Wrapper>
  );
}

export default PromoPageV1